.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: map.get($spacing-scale, 'md');

  // Mobile: plain white background, no gradient
  @media (max-width: $breakpoint-tablet) {
    background: var(--color-surface-primary) !important;
    padding: map.get($spacing-scale, 'lg') map.get($spacing-scale, 'md');
    align-items: flex-start;
    padding-top: map.get($spacing-scale, '3xl');
  }
}

.card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  padding: map.get($spacing-scale, 'xl');
  background-color: var(--color-surface-primary);
  border-radius: map.get($radius, 'lg');
  box-shadow: map.get($shadows, 'xl');

  // Mobile: no card styling, just content
  @media (max-width: $breakpoint-tablet) {
    max-width: 100%;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    min-height: calc(100vh - map.get($spacing-scale, '3xl') - map.get($spacing-scale, 'lg'));
    justify-content: space-between;
  }
}

.cardContent {
  display: flex;
  flex-direction: column;
  min-height: 340px; // Consistent height across all states (matches email entry init)
}

// Email Screen
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: map.get($spacing-scale, 'sm');
  margin-bottom: map.get($spacing-scale, 'lg');
  text-align: center;
}

.subtitle {
  @include body-regular;
  color: var(--color-text-secondary);
  margin: 0;
  max-width: 280px;

  strong {
    color: var(--color-text-primary);
    font-weight: map.get($font-weights, 'medium');
  }
}

.form {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'sm');
}

.ssoButtons {
  display: flex;
  flex-direction: column;
  gap: map.get($spacing-scale, 'sm');
  margin-top: map.get($spacing-scale, 'sm');
}

.footer {
  margin-top: map.get($spacing-scale, 'lg');
  text-align: center;

  @media (max-width: $breakpoint-tablet) {
    margin-top: auto;
    padding-top: map.get($spacing-scale, 'xl');
  }
}

.footerText {
  @include caption-regular;
  color: var(--color-text-tertiary);
  margin: 0;
}

.footerLink {
  color: var(--color-primary-base);
  text-decoration: none;

  @include transition(color);

  &:hover {
    color: var(--color-primary-dark);
    text-decoration: underline;
  }
}

// OTP Screen
.otpSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: map.get($spacing-scale, 'md');
}

.otpInstruction {
  @include body-medium;
  color: var(--color-text-primary);
  text-align: center;
  margin: 0;
}

.otpForm {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 80px; // Match InputOTP cell height to prevent layout shift
}

// Authenticating State (post-SSO, before redirect)
.authenticatingSpinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: map.get($spacing-scale, 'sm');
  flex: 1;
  min-height: 120px;
}

// Verifying State
.verifyingSpinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: map.get($spacing-scale, 'sm');
  height: 80px; // Match InputOTP cell height
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid var(--color-grey-soft);
  border-top-color: var(--color-primary-base);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.verifyingText {
  @include body-small-medium;
  color: var(--color-text-secondary);
  margin: 0;
}
